import React, { useEffect, useState} from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("user") !== null);

    useEffect(() => {
        checkLoggedInStatus();
    }, []);

    const checkLoggedInStatus = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'user_loged', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
                },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user")})
            }
            )
            .then(response => response.text())
            .then(data => {
                setIsLoggedIn(data === 'ok');
            })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    return (
        <nav className="bg-gray-800">
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                <div className="relative flex h-16 items-center justify-between">

                    <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                        <div className="hidden sm:ml-6 sm:block">
                            <div className="flex space-x-4">
                                <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                    <Link to="/">Home</Link>
                                </div>
                                <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                    <Link to="/reviews">Reviews</Link>
                                </div>
                                
                                {isLoggedIn && localStorage.getItem("user") === 'lcentellas' ? (
                                    <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                        <Link to="/diffs">Diffs</Link>
                                    </div>
                                ) : null}

                                <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                    <Link to="/commits">Commits</Link>
                                </div>

                                {isLoggedIn && (localStorage.getItem("user") === 'lcentellas' || localStorage.getItem("user") === 'jalonsol') ? (
                                    <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                        <Link to="/discrepancies">Discrepancies</Link>
                                    </div>
                                ) : null}

                                <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                    <Link to="/genReviews">Generated Reviews</Link>
                                </div>

                                {isLoggedIn && (localStorage.getItem("user") === 'lcentellas' || localStorage.getItem("user") === 'jalonsol') ? (
                                    <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                        <Link to="/genReviewsDiffs">Generated Reviews Diffs</Link>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                        {isLoggedIn ? (
                            <>
                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                            {localStorage.getItem("user")}
                                        </div>
                                    </div>
                                </div>
                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                            <Link to="/logout">Logout</Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="hidden sm:ml-6 sm:block">
                                <div className="flex space-x-4">
                                    <div className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                                        <Link to="/login">Login</Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="sm:hidden" id="mobile-menu">
                <div className="space-y-1 px-2 pb-3 pt-2">
                    <div className="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white">
                        <Link to="/">Home</Link>
                    </div>
                    <div className="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white">
                        <Link to="/reviews">Reviews</Link>
                    </div>
                    <div className="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white">
                        {isLoggedIn ? (
                            <Link to="/logout">Logout</Link>
                        ) : (
                            <Link to="/login">Login</Link>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;